import * as PIXI from "pixi.js";

import { AbstractGameMode } from "../../../abstracts/flow/AbstractGameMode";
import { AbstractView } from "../../../abstracts/modules/AbstractView";
import { BackgroundNames } from "../../../abstracts/types/enums";
import { ColorSet, log } from "../../../abstracts/utils/AbstractConsole";

export class DDDBackgroundView extends AbstractView {
    private normalBackground: PIXI.Container;
    private freespinBackground: PIXI.Sprite;
    private superFreespinBackground: PIXI.Sprite;
    private respinBackground: PIXI.Sprite;

    constructor() {
        super(`DDDBackgroundView`);
    }

    private swapBackgroundTo(newBackground: PIXI.Sprite | PIXI.Container) {
        newBackground.position.set(-480);

        this.addChildAt(newBackground, 0);
        if (this.children.length > 1) {
            this.removeChildren(1);
        }

        log(`DDDBackgroundView set ` + this.gameMode.toString(), ColorSet.BLACK);
    }

    private createNormalBackground(): PIXI.Container {
        const backgroundContainer = new PIXI.Container();
        backgroundContainer.name = BackgroundNames.NORMAL;

        const bgImage = new PIXI.Sprite(PIXI.Texture.from(BackgroundNames.NORMAL));
        backgroundContainer.addChild(bgImage);

        return backgroundContainer;
    }

    protected initGraphics(): void {
        this.normalBackground = this.createNormalBackground();

        this.freespinBackground = new PIXI.Sprite(PIXI.Texture.from(BackgroundNames.FREESPIN));
        this.superFreespinBackground = new PIXI.Sprite(
            PIXI.Texture.from(BackgroundNames.SUPER_FREESPIN)
        );
        this.respinBackground = new PIXI.Sprite(PIXI.Texture.from(BackgroundNames.RESPIN));
    }

    protected onGameModeUpdate() {
        super.onGameModeUpdate();

        switch (this.gameMode) {
            case AbstractGameMode.FREESPIN:
                this.swapBackgroundTo(this.freespinBackground);
                break;

            case AbstractGameMode.SUPER_FREESPIN:
                this.swapBackgroundTo(this.superFreespinBackground);
                break;

            case AbstractGameMode.RESPIN:
                this.swapBackgroundTo(this.respinBackground);
                break;

            default:
                this.swapBackgroundTo(this.normalBackground);

                break;
        }
    }

    public showNextBackground(newGameMode: AbstractGameMode) {
        this.gameMode = newGameMode;

        switch (newGameMode) {
            case AbstractGameMode.FREESPIN:
                this.swapBackgroundTo(this.freespinBackground);
                break;

            case AbstractGameMode.SUPER_FREESPIN:
                this.swapBackgroundTo(this.superFreespinBackground);
                break;

            case AbstractGameMode.RESPIN:
                this.swapBackgroundTo(this.respinBackground);
                break;

            default:
                this.swapBackgroundTo(this.normalBackground);

                break;
        }
    }

    public onOrientationChanged() {
        //handle
    }
}
